import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useEffect } from 'react';

var isOwapApp = function isOwapApp() {
  if (typeof window === 'undefined') {
    return false;
  }
  return sessionStorage.getItem('owapApp') === 'true';
};
var getOwapWebviewType = function getOwapWebviewType() {
  var _ref;
  if (typeof window === 'undefined') {
    return null;
  }
  return (_ref = sessionStorage.getItem('owapWebviewType')) !== null && _ref !== void 0 ? _ref : null;
};
var useOwapInfo = function useOwapInfo() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOwap = _useState2[0],
    setIsOwapApp = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    owapWebviewType = _useState4[0],
    setOwapWebviewType = _useState4[1];
  useEffect(function () {
    setIsOwapApp(isOwapApp());
    setOwapWebviewType(getOwapWebviewType());
  }, []);
  return {
    isOwap: isOwap,
    owapWebviewType: owapWebviewType
  };
};

export { getOwapWebviewType, isOwapApp, useOwapInfo };
//# sourceMappingURL=webview.js.map
